module.exports = __webpack_public_path__ + "static/media/generalSurgery-image2.69892f20.png";